// extracted by mini-css-extract-plugin
export default {"container":"footer-component_container__GQQ7V","text":"footer-component_text__KtgyY"};